/** Returns true when the given pathname is inside the Procore plugin shell.
 *  Anchored on a `/procore` segment (followed by `/` or end of string) so it
 *  doesn't accidentally match unrelated routes like `/admin/procore-settings`. */
export function isProcorePath(pathname: string | null | undefined): boolean {
  if (!pathname) return false;
  return /\/procore(\/|$)/.test(pathname);
}
